"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestWindow = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const ApiCall_helper_1 = require("../helpers/ApiCall.helper");
//@ts-ignore                
let rwsTemplate = T.html `
<div id="testing-window">
  <div class="testers-list">
    ${(0, fast_element_1.repeat)(x => x.testers, (0, fast_element_1.html) `    
      <div class="tester-item ${(x, c) => c.parent.startedTesters.some(started => started.id === x.id) ? 'started' : ''}">
        <div class="tester-header">
          <div class="tester-status">
            ${(0, fast_element_1.when)((x, c) => c.parent.startedTesters.some(started => started.id === x.id), (0, fast_element_1.html) `
              <i class="simple-icon-check status-check"></i>
            `)}
          </div>
          <div class="tester-info">
            <h3 class="tester-name">${x => x.name}</h3>
            <div class="tester-metadata">
              <span class="metadata-item">
                <i class="simple-icon-settings"></i>
                ${x => x.messagesCount} ${'botTest.messages'.t()}
              </span>
              <span class="metadata-item">
                <i class="simple-icon-target"></i>
                ${x => { var _a; return ((_a = x.targets) === null || _a === void 0 ? void 0 : _a.length) || 0; }} ${'botTest.targets'.t()}
              </span>
            </div>
          </div>
        </div>
        
        <div class="tester-targets">
          ${(0, fast_element_1.repeat)(x => x.targets, (0, fast_element_1.html) `
            <div class="target-item">
              <i class="simple-icon-user"></i>
              <span class="target-name">${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.name) || 'Unknown Avatar'; }}</span>
            </div>
          `)}
        </div>
      </div>
    `)}
  </div>

  ${(0, fast_element_1.when)(x => x.testers.length === 0, (0, fast_element_1.html) `
    <div class="empty-state">
      <i class="simple-icon-list"></i>
      <p>${'botTest.noTesters'.t()}</p>
    </div>
  `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `#testing-window {
  padding: 16px;
  background: #f8f9fa;
  min-height: 400px;
}

.testers-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tester-item {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.tester-item:hover {
  border-color: #0066cc;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
}
.tester-item.started {
  border-color: #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
}
.tester-item.started .tester-header .tester-name {
  color: #155724;
}

.tester-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.tester-status {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f8f9fa;
}
.tester-status .status-check {
  color: #28a745;
  font-size: 16px;
  font-weight: bold;
}

.tester-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tester-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
  line-height: 1.2;
}

.tester-metadata {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.metadata-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6c757d;
}
.metadata-item i {
  font-size: 12px;
  color: #adb5bd;
}

.tester-targets {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 44px;
}

.target-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 14px;
}
.target-item i {
  color: #6c757d;
  font-size: 12px;
}
.target-item .target-name {
  color: #495057;
  font-weight: 500;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
  text-align: center;
}
.empty-state i {
  font-size: 48px;
  color: #dee2e6;
  margin-bottom: 16px;
}
.empty-state p {
  margin: 0;
  font-size: 16px;
}

@media (max-width: 768px) {
  #testing-window {
    padding: 12px;
  }
  .tester-item {
    padding: 12px;
  }
  .tester-metadata {
    flex-direction: column;
    gap: 8px;
  }
  .tester-targets {
    padding-left: 0;
  }
}`;
const shadowOptions = { "mode": "open" };
let BotTestWindow = class BotTestWindow extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.testers = [];
        this.startedTesters = [];
    }
    async connectedCallback() {
        super.connectedCallback();
        this.runTest();
    }
    runTest() {
        console.log('Running test with testers:', this.testers);
        ApiCall_helper_1.ApiCallHelper.runTest.bind(this)(this.testers);
    }
    startedTester(tester) {
        this.startedTesters = [...this.startedTesters, tester];
        console.log({ startedTesters: this.startedTesters });
    }
};
exports.BotTestWindow = BotTestWindow;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestWindow.prototype, "testers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestWindow.prototype, "startedTesters", void 0);
exports.BotTestWindow = BotTestWindow = __decorate([
    (0, client_1.RWSView)('bot-test-window', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], BotTestWindow);
BotTestWindow.defineComponent();
